<div class="title mb-4">
  <h2>Forum Categories</h2>
</div>

<div class="row">
  <div class="col-lg-12 col-md-12">
    <div class="white_box shadow p-3">
      <form>
        <div class="mb-3 row">
          <!-- <label for="table-filtering-search" class="col-xs-3 col-sm-auto col-form-label">Full text search:</label> -->
          <div class="col-xs-3 col-sm-auto">
            <button
              (click)="openForm(categoryForm)"
              class="btn btn-success btn-sm mb-2"
            >
              <i class="fa-solid fa-plus"></i> Create
            </button>
          </div>
          <div class="col-xs-3 col-sm-auto">
            <input
              id="table-filtering-search"
              class="form-control"
              type="text"
              placeholder="Search"
              [formControl]="filter"
            />
          </div>
        </div>
      </form>

      <!-- Table -->
      <section>
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Category</th>
              <th scope="col">Forum Count</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            <ng-container
              *ngFor="let item of categories; track: item?.name; index as i"
            >
              <tr>
                <th scope="row">{{ i + 1 }}</th>
                <td>{{ item?.name }}</td>
                <td>{{ item?.forumCount }}</td>
                <td>
                  <div class="btn-group">
                    <button
                      class="btn btn-sm btn-warning"
                      (click)="openForm(categoryForm, item)"
                    >
                      <i class="fa-solid fa-edit"></i> Edit
                    </button>
                    <button
                      class="btn btn-sm btn-danger"
                      (click)="deleteCategory(item.id)"
                    >
                      <i class="fa-solid fa-trash"></i> Delete
                    </button>
                  </div>
                </td>
              </tr>
            </ng-container>

            <!-- <tr>
																	<td colspan="4" style="text-align: center">No countries found</td>
															</tr> -->
          </tbody>
        </table>
      </section>
      <!-- Table -->
    </div>
  </div>
</div>
<ng-template #categoryForm let-modal>
  <div
    id="form_modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-body">
      <h5 class="text-center">Form Category</h5>
      <div class="form-group">
        <label for="">Message</label>
        <input type="text" class="form-control" [(ngModel)]="category.name" />
      </div>
    </div>
    <div class="modal-footer">
      <button
        class="btn btn-danger mr-2"
        [disabled]="category?.hasSubmit"
        (click)="modalService.dismissAll()"
      >
        <i class="fa-solid fa-times"></i> Cancel
      </button>
      <button
        class="btn btn-primary"
        (click)="categoryStore()"
        [disabled]="category?.hasSubmit"
      >
        <i class="fa-solid fa-paper-plane"></i> Submit
      </button>
    </div>
  </div>
</ng-template>
